(() => {
  if (window.neptuneFacetsControllerInitialized) return;
  window.neptuneFacetsControllerInitialized = true;
  if (!window.neptuneFacetDismissInitialized) {
    window.neptuneFacetDismissInitialized = true;

    document.addEventListener('pointerdown', (event) => {
      document.querySelectorAll('.neptune-facets__group[open]').forEach((group) => {
        if (!group.contains(event.target)) group.open = false;
      });
      if (window.matchMedia('(max-width: 749px)').matches) {
        document.querySelectorAll('[data-mobile-filters][open]').forEach((drawer) => {
          if (!drawer.contains(event.target)) drawer.open = false;
        });
      }
    });

    document.addEventListener('toggle', (event) => {
      const opened = event.target;
      if (!opened.matches?.('.neptune-facets__group') || !opened.open) return;
      document.querySelectorAll('.neptune-facets__group[open]').forEach((group) => {
        if (group !== opened) group.open = false;
      });
    }, true);

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      const focusedGroup = event.target.closest?.('.neptune-facets__group[open]');
      const group = focusedGroup || document.querySelector('.neptune-facets__group[open]');
      const drawer = window.matchMedia('(max-width: 749px)').matches
        ? document.querySelector('[data-mobile-filters][open]') : null;
      const disclosure = group || drawer;
      if (!disclosure) return;
      disclosure.open = false;
      disclosure.querySelector('summary')?.focus({ preventScroll: true });
      event.preventDefault();
    });
  }

  let request;
  let revision = 0;
  let timer;
  const cleanup = new WeakMap();
  const loading = new WeakMap();
  const stopSkeleton = (section) => {
    const state = loading.get(section);
    if (!state) return;
    clearTimeout(state.timer);
    state.grid.classList.remove('has-loading-skeleton');
    state.grid.inert = state.inert;
    loading.delete(section);
  };
  const startSkeleton = (section) => {
    const grid = section.querySelector('.collection-products, .neptune-search__results');
    if (!grid) return;
    const state = { grid, inert: grid.inert };
    state.timer = setTimeout(() => {
      grid.classList.add('has-loading-skeleton');
      grid.inert = true;
    }, 120);
    loading.set(section, state);
  };
  const cancel = () => {
    revision += 1;
    request?.abort();
    clearTimeout(timer);
    document.querySelectorAll('.is-filter-loading').forEach((section) => {
      stopSkeleton(section);
      section.removeAttribute('aria-busy');
      section.classList.remove('is-filter-loading');
      const status = section.querySelector('[data-facet-status]');
      if (status) status.textContent = '';
    });
  };
  const statusFor = (section) => section.querySelector('[data-facet-status]');
  const update = async (form, url, historyMode = 'push', scrollProducts = false) => {
    cancel();
    const version = revision;
    const section = form.closest('.shopify-section');
    if (!section) return;
    request = new AbortController();
    const sectionId = section.id.replace(/^shopify-section-/, '');
    const endpoint = new URL(url);
    endpoint.searchParams.set('sections', sectionId);
    section.setAttribute('aria-busy', 'true');
    section.classList.add('is-filter-loading');
    startSkeleton(section);
    const status = statusFor(section);
    if (status) status.textContent = status.dataset.updating;
    try {
      let page;
      try {
        const response = await fetch(endpoint, { signal: request.signal, credentials: 'same-origin', headers: { Accept: 'application/json' } });
        if (response.ok) {
          const payload = await response.json();
          if (payload[sectionId]) page = new DOMParser().parseFromString(payload[sectionId], 'text/html');
        }
      } catch (error) {
        if (error.name === 'AbortError') throw error;
      }
      if (version !== revision) return;
      let next = page?.getElementById(section.id);
      if (!next?.querySelector('[data-facets-form]')) {
        const fallback = new URL(url);
        const response = await fetch(fallback, { signal: request.signal, credentials: 'same-origin', headers: { Accept: 'text/html' } });
        if (!response.ok) throw new Error('Filtered page unavailable');
        page = new DOMParser().parseFromString(await response.text(), 'text/html');
        next = page.querySelector('[data-facets-form]')?.closest('.shopify-section');
      }
      if (version !== revision) return;
      if (!next?.querySelector('[data-facets-form]')) throw new Error('Filtered section missing');
      const drawerOpen = form.querySelector('[data-mobile-filters]')?.open;
      const groups = new Map([...form.querySelectorAll('.neptune-facets__group')].map((group) => [group.dataset.facetKey, { open: group.open, scroll: group.querySelector('.neptune-facets__panel')?.scrollTop || 0 }]));
      const active = document.activeElement;
      const focus = form.contains(active) ? { name: active.name, value: active.value, id: active.id, group: active.closest('.neptune-facets__group')?.dataset.facetKey, summary: active.tagName === 'SUMMARY' } : null;
      const scroll = { x: window.scrollX, y: window.scrollY };
      cleanup.get(form)?.();
      stopSkeleton(section);
      section.replaceChildren(...next.childNodes);
      init();
      const nextForm = section.querySelector('[data-facets-form]');
      const drawer = nextForm.querySelector('[data-mobile-filters]');
      if (drawer && drawerOpen !== undefined) drawer.open = drawerOpen;
      nextForm.querySelectorAll('.neptune-facets__group').forEach((group) => {
        const saved = groups.get(group.dataset.facetKey);
        if (!saved) return;
        group.open = saved.open;
        const panel = group.querySelector('.neptune-facets__panel');
        if (panel) panel.scrollTop = saved.scroll;
      });
      if (focus) {
        let target;
        if (focus.summary) {
          const group = [...nextForm.querySelectorAll('.neptune-facets__group')].find((item) => item.dataset.facetKey === focus.group);
          target = (group || drawer)?.querySelector('summary');
        } else target = [...nextForm.elements].find((item) => focus.id ? item.id === focus.id : item.name === focus.name && (item.type !== 'checkbox' || item.value === focus.value));
        target?.focus({ preventScroll: true });
      }
      const products = section.querySelector('.collection-products, .neptune-search__results');
      if (scrollProducts && products) {
        requestAnimationFrame(() => {
          if (version !== revision || !products.isConnected) return;
          const header = document.querySelector('.site-header');
          const headerPosition = header && getComputedStyle(header).position;
          const headerBounds = header?.getBoundingClientRect();
          const headerHeight = (headerPosition === 'sticky' || headerPosition === 'fixed') && headerBounds.bottom > 0 ? headerBounds.height : 0;
          window.scrollTo({
            top: Math.max(0, window.scrollY + products.getBoundingClientRect().top - headerHeight - 12),
            left: scroll.x,
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
          });
        });
      } else window.scrollTo(scroll.x, scroll.y);
      if (historyMode === 'push' && url.href !== window.location.href) history.pushState({}, '', url);
      const nextStatus = statusFor(section);
      const count = section.querySelector('.collection-header__count, .neptune-search__count');
      if (nextStatus && count) nextStatus.textContent = count.textContent.trim();
      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        section.querySelector('.collection-products, .neptune-search__results, .collection-empty, .neptune-search__empty')?.animate?.([{ opacity: .4 }, { opacity: 1 }], { duration: 200, easing: 'ease-out' });
      }
    } catch (error) {
      if (error.name === 'AbortError' || version !== revision) return;
      console.warn('[Neptune filters]', error.message);
      const currentStatus = statusFor(section);
      if (currentStatus) currentStatus.textContent = currentStatus.dataset.error;
    } finally {
      if (version === revision) {
        stopSkeleton(section);
        section.removeAttribute('aria-busy');
        section.classList.remove('is-filter-loading');
      }
    }
  };
  const formUrl = (form) => {
    const url = new URL(form.action, window.location.href);
    const data = new FormData(form);
    url.search = '';
    for (const [key, value] of data) {
      if (String(value).trim() !== '') url.searchParams.append(key, value);
    }
    const current = new URL(window.location.href);
    ['preview_theme_id', '_fd', 'pb'].forEach((key) => {
      if (current.searchParams.has(key)) url.searchParams.set(key, current.searchParams.get(key));
    });
    return url;
  };
  const init = () => {
    document.querySelectorAll('[data-facets-form]').forEach((form) => {
      if (form.dataset.facetsInitialized === 'true') return;
      form.dataset.facetsInitialized = 'true';
      const mobileFilters = form.querySelector('[data-mobile-filters]');
      const mobileViewport = window.matchMedia('(max-width: 749px)');
      const syncFilterDisclosure = () => { if (mobileFilters) mobileFilters.open = !mobileViewport.matches; };
      syncFilterDisclosure();
      mobileViewport.addEventListener('change', syncFilterDisclosure);
      cleanup.set(form, () => mobileViewport.removeEventListener('change', syncFilterDisclosure));
      const apply = () => { if (form.reportValidity()) update(form, formUrl(form)); };
      const schedule = (delay) => {
        cancel();
        timer = setTimeout(apply, delay);
      };
      form.addEventListener('change', (event) => {
        if (!event.target.matches('input[type="checkbox"], input[type="number"], input[type="radio"][name="sort_by"]')) return;
        if (event.target.name === 'sort_by') {
          const menu = event.target.closest('[data-sort-menu]');
          const label = event.target.closest('label')?.querySelector('span');
          const current = menu?.querySelector('[data-sort-current]');
          if (current && label) current.textContent = label.textContent;
          if (menu) {
            menu.open = false;
            menu.querySelector('summary')?.focus({ preventScroll: true });
          }
        }
        schedule(event.target.type === 'checkbox' ? 250 : 0);
      });
      form.addEventListener('input', (event) => {
        if (event.target.matches('input[type="number"]')) schedule(700);
      });
      form.addEventListener('submit', (event) => {
        if (!form.closest('.shopify-section')) return;
        event.preventDefault();
        apply();
      });
      form.closest('.neptune-facets')?.classList.add('is-enhanced');
    });
  };
  document.addEventListener('click', (event) => {
    const link = event.target.closest('.neptune-pagination a, .neptune-facets__active a, .neptune-facets__clear, .collection-empty a');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const form = link.closest('.shopify-section')?.querySelector('[data-facets-form]');
    if (!form) return;
    const url = new URL(link.href);
    if (url.origin !== window.location.origin) return;
    event.preventDefault();
    const current = new URL(window.location.href);
    ['preview_theme_id', '_fd', 'pb'].forEach((key) => {
      if (current.searchParams.has(key)) url.searchParams.set(key, current.searchParams.get(key));
    });
    update(form, url, 'push', Boolean(link.closest('.neptune-pagination')));
  });
  window.addEventListener('popstate', () => {
    const form = document.querySelector('[data-facets-form]');
    if (form) update(form, new URL(window.location.href), 'none');
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();
